/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Console_Open_InInputs */

const en_console_open_in = /** @type {(inputs: Console_Open_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open in`)
};

const zh_hans1_console_open_in = /** @type {(inputs: Console_Open_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开于`)
};

const pt_br2_console_open_in = /** @type {(inputs: Console_Open_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir em`)
};

const es_console_open_in = /** @type {(inputs: Console_Open_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir en`)
};

const fr_console_open_in = /** @type {(inputs: Console_Open_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir dans`)
};

const de_console_open_in = /** @type {(inputs: Console_Open_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öffnen in`)
};

const ru_console_open_in = /** @type {(inputs: Console_Open_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Открыть в`)
};

const it_console_open_in = /** @type {(inputs: Console_Open_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri in`)
};

/**
* | output |
* | --- |
* | "Open in" |
*
* @param {Console_Open_InInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const console_open_in = /** @type {((inputs?: Console_Open_InInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Console_Open_InInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_console_open_in(inputs)
	if (locale === "pt-BR") return pt_br2_console_open_in(inputs)
	if (locale === "es") return es_console_open_in(inputs)
	if (locale === "fr") return fr_console_open_in(inputs)
	if (locale === "de") return de_console_open_in(inputs)
	if (locale === "ru") return ru_console_open_in(inputs)
	if (locale === "it") return it_console_open_in(inputs)
	return en_console_open_in(inputs)
});